import React, { useEffect, useRef } from "react";

const safeDivide = (a, b) => {
  const numA = Number(a);
  const numB = Number(b);

  if (!Number.isFinite(numA) || !Number.isFinite(numB) || numB === 0) {
    return 0;
  }

  return numA / numB;
};

const PriceChange = ({
  value = 0,
  subValue,
  isSubValue = false,
  isDevide = false,
  isLiveMarket = false,
}) => {
  const prevValueRef = useRef(0);
  const priceUpDownRef = useRef(null);
  const spanRef = useRef(null); // Reference for direct class manipulation

  useEffect(() => {
    if (prevValueRef.current !== null && value !== prevValueRef.current) {
      if (value > prevValueRef.current) {
        priceUpDownRef.current = "text_animated-up";
      } else if (value < prevValueRef.current) {
        priceUpDownRef.current = "text_animated-down";
      }

      // Directly apply class without triggering a state update
      if (spanRef.current) {
        spanRef.current?.classList.add(priceUpDownRef.current);
        setTimeout(() => {
          spanRef.current?.classList.remove(
            "text_animated-up",
            "text_animated-down",
          );
        }, 1000);
      }
    }

    prevValueRef.current = value;
  }, [value]);

  return (
    <span
      className={`price-container ${isLiveMarket ? "live-market" : ""}`}
      ref={spanRef}
    >
      <span className="text_span">{value ?? 0}</span>

      {isSubValue && (
        <span className="text_span text_gray font_small">
          {isDevide
            ? safeDivide(subValue, value).toFixed(2)
            : subValue.toFixed(2)}
        </span>
      )}
    </span>
  );
};

export default PriceChange;
